<template>
<div>

	<div class="d-flex flex-wrap justify-content-between align-items-center">
		<div class="d-flex mb-1" v-if="!hideTotals">
			<info-box label="Total Revenue" stacked="true" :value="'$' +renderedReport.totalRevenue"></info-box>
			<info-box label="Total Expenses" stacked="true" :value="'$' +renderedReport.totalExpenses"></info-box>
			<info-box label="Total Labour" stacked="true" :value="'$' +renderedReport.totalLabour"></info-box>
		</div>
		<div>
			<field v-if="!hidePeriodSelector"
				label="Period"
				col-class="col-auto"
				:params="{type:'select',options: periodOptions}"
				v-model="reportPeriod"
				v-on:change="periodChange">
			</field>
			<slot name="controls"></slot>
		</div>
	</div>

	<h5 v-if="heading">{{heading}}</h5>

	<chart v-if="renderGraph"
		type="line"
		height="260"
		:datasets="renderedReport.datasets"
		:labels="renderedReport.labels"
		:options="options"
		v-on:click="$emit('chartClick')">
	</chart>
	<div v-else style="height: 260px;display: flex;align-items: center;">
		<spinner inline="true"></spinner>
	</div>
</div>
</template>
<script type="text/javascript">
import Chart from "@/components/Chart"
import Field from "@/components/Field"
import InfoBox from "@/components/InfoBox"
import Spinner from "@/components/Spinner"

export default {
	name: "CustomerRevenueGraph",
	components: {
		Chart,
		Field,
		InfoBox,
		Spinner
	},
	props: [
		"customerId",
		"interval", //year, month, week, day
		"aggregationType", //accumulated, interval-totaled
		"hidePeriodSelector",
		"hideTotals",
		"value",
		"sources", //['projects','services']
		"heading",
		"delayFetch"
	],
	data() {
		return {
			renderGraph: false,
			reportRecordsServices: [],
			reportRecordsProjects: [],
			renderedReport: {
				totalRevenue: "0.00",
				totalLabour: "0.00",
				totalExpenses: "0.00",
				totalActualCosts: "0.00",
				datasets: [],
				labels: null
			},
			reportPeriod: "customer-lifespan",
			selectedDateRange: {
				from_year: 2020,
				from_month: 1,
				to_year: 2020,
				to_month: 12
			},
			sourcesLocal: []
		}
	},
	watch: {
		aggregationType() {
			this.reRenderGraph()
		},
		value() {
			if (this.value) {
				this.reportPeriod = this.value				
				this.periodChange(this.value)
			}
		},
		customerId() {
			this.fetchReportRange(
				this.dateStart.format("YYYY"),
				this.dateStart.format("M"),
				this.dateEnd.format("YYYY"),
				this.dateEnd.format("M")
			)
		},
		delayFetch() {
			if (!this.delayFetch && this.customerId) {
				this.fetchReportRange(
					this.dateStart.format("YYYY"),
					this.dateStart.format("M"),
					this.dateEnd.format("YYYY"),
					this.dateEnd.format("M")
				)
			}
		}
	},
	computed: {
		periodOptions() {
			if (this.interval == 'week') {

			}
			else if (this.interval == 'day') {
				//get quarters since customer or company was created
				let endDate = this.moment(this.$store.company.created_at)
				if (this.$store.contact.created_at) 
					endDate = this.moment(this.$store.contact.created_at)

				let months = [], theDate = this.moment()
				while (theDate > endDate) {
					months.push({
						value: theDate.format("YYYY-MM-01")+","+theDate.endOf('month').format("YYYY-MM-DD"),
						text: theDate.format("MMM YYYY")
					})

					theDate.subtract(1,"months")
				}

				return months
			}
			else {
				return [
					{text: 'Customer Lifespan',value:'customer-lifespan'},
					{text: 'Last 12 Months',value:'last-12-months'},
					{text: 'Last 6 Months',value:'last-6-months'},
					{text: 'Last 3 Months',value:'last-3-months'}
				]
			}
		},
		options() {
			return {
				tooltips: {
					callbacks: {
						label(item,data) {
							let value = +item.value

							return "$ " + value.toCurrency()
						}
					}
					
				},
				scales: {
					yAxes: [{
						ticks: {
							callback(value,index,values) {
								return '$ '+ value.toCurrency()
							}
						}
					}]
				}
			}
		},
		dateStart() {
			if (this.reportPeriod == "customer-lifespan") {
				if (this.$store.contact.created_at)
					return this.moment(this.$store.contact.created_at)
				else
					return this.moment(this.$store.company.created_at)
			}
			else if (this.reportPeriod == "last-12-months")
				return this.moment().subtract(12,"months")
			else if (this.reportPeriod == "last-6-months")
				return this.moment().subtract(6,"months")
			else if (this.reportPeriod == "last-3-months")
				return this.moment().subtract(3,"months")
			else if (this.reportPeriod.split(',').length == 2) {
				//this period value has start,end range
				let range = this.reportPeriod.split(',')

				return this.moment(range[0])
			}
			else
				return this.moment()
		},
		dateEnd() {
			let dateEnd
			if (this.reportPeriod == "customer-lifespan")
				dateEnd = this.moment()
			else if (this.moment(this.reportPeriod).isValid())
				return this.moment(this.reportPeriod)
			else if (this.reportPeriod.split(',').length == 2) {
				//this period value has start,end range
				let range = this.reportPeriod.split(',')

				return this.moment(range[1])
			}
			else
				dateEnd = this.moment()

			return dateEnd
		},
	},
	methods: {
		reRenderGraph() {
			this.renderGraph = false
			this.$nextTick(() => {
				this.renderReport()
				this.renderGraph = true
			})
		},
		periodChange(value) {
			let vm = this

			this.$nextTick(() => {

				vm.fetchReportRange(
					vm.dateStart.format("YYYY"),
					vm.dateStart.format("M"),
					vm.dateEnd.format("YYYY"),
					vm.dateEnd.format("M")
				)

				vm.$emit("input",value)
			})
		},
		renderReport() {
			let vm = this

			this.renderedReport = {
				totalRevenue: "0.00",
				totalLabour: "0.00",
				totalExpenses: "0.00",
				datasets: []
			}

			let revenue = [], expenses = [], labour = [], labels = []
			let cumulativeRevenue = 0, cumulativeExpenses = 0, cumulativeLabour = 0

			let iterableSet = this.reportRecordsServices
			if (this.sourcesLocal.indexOf('services') == -1)
				iterableSet = this.reportRecordsProjects

			iterableSet.forEach((record,index) => {
				let monthlyRevenue = 0, monthlyExpenses = 0, monthlyLabour = 0

				let datapointsService = {}, datapointsProject = {}

				try {
					datapointsService = JSON.parse(vm.reportRecordsServices[index].report_json)

					if ("revenue" in datapointsService) 
						cumulativeRevenue += +datapointsService.revenue
					
					if ("expenses" in datapointsService) 
						cumulativeExpenses += +datapointsService.expenses
						
					if ("labour" in datapointsService) 
						cumulativeLabour += +datapointsService.labour
				}
				catch (e) {}
				try {
					datapointsProject = JSON.parse(vm.reportRecordsProjects[index].report_json)

					if ("revenue" in datapointsProject) 
						cumulativeRevenue += +datapointsProject.revenue

					if ("expenses" in datapointsProject) 
						cumulativeExpenses += +datapointsProject.expenses
						
					if ("labour" in datapointsProject) 
						cumulativeLabour += +datapointsProject.labour
				}
				catch (e) {}

				if (vm.aggregationType == 'cumulative') {
					expenses.push(cumulativeExpenses)
					revenue.push(cumulativeRevenue)
					labour.push(cumulativeLabour)
				}
				else if (vm.aggregationType == 'interval-totaled') {
					if ("revenue" in datapointsService) 
						monthlyRevenue += +datapointsService.revenue
					
					if ("expenses" in datapointsService) 
						monthlyExpenses += +datapointsService.expenses
						
					if ("labour" in datapointsService) 
						monthlyLabour += +datapointsService.labour

					if ("revenue" in datapointsProject) 
						monthlyRevenue += +datapointsProject.revenue

					if ("expenses" in datapointsProject) 
						monthlyExpenses += +datapointsProject.expenses
						
					if ("labour" in datapointsProject) 
						monthlyLabour += +datapointsProject.labour

					expenses.push(monthlyExpenses)
					revenue.push(monthlyRevenue)
					labour.push(monthlyLabour)
				}

				if (vm.interval == 'day')
					labels.push(vm.moment(record.date).format("MMM DD"))
				else
					labels.push(vm.moment(record.date).format("MMM YYYY"))

			})

			this.renderedReport = {
				totalRevenue: cumulativeRevenue.toCurrency(),
				totalLabour: cumulativeLabour.toCurrency(),
				totalExpenses: cumulativeExpenses.toCurrency(),
				datasets: [
					{
						label: 'Gross Revenue',
						lineTension: 0,
						borderColor: '#ECBA00',
						fill: false,
						data: revenue
					},
					{
						label: 'Labour',
						lineTension: 0,
						borderColor: 'blue',
						fill: false,
						data: labour
					},
					{
						label: 'Expenses',
						lineTension: 0,
						borderColor: 'red',
						fill: false,
						data: expenses
					}
				],
				labels
			}
		},
		fetchReportRange(from_year,from_month,to_year,to_month) {
			let vm = this

			if (!this.delayFetch) {

				this.renderGraph = false

				let promises = []

				let projectIndex,serviceIndex, report_type
				if (this.sourcesLocal.indexOf('projects') >= 0) {

					if (this.interval == 'day')
						report_type = "total-daily-project-billing-customer"
					else
						report_type = "total-monthly-project-billing-customer"

					let paramsProjects = {
						from_year,
						from_month,
						to_year,
						to_month,
						customer_id: this.customerId,
						report_type
					}

					projectIndex = 0
					promises.push(this.getJSON("JobReport/get-range",paramsProjects))
				}

				if (this.sourcesLocal.indexOf('services') >= 0) {

					if (this.interval == 'day')
						report_type = "total-daily-service-billing-customer"
					else
						report_type = "total-monthly-service-billing-customer"

					let paramsServices = {
						from_year,
						from_month,
						to_year,
						to_month,
						customer_id: this.customerId,
						report_type
					}

					serviceIndex = promises.length
					promises.push(this.getJSON("JobReport/get-range",paramsServices))
				}

				Promise.all(promises).then(responses => {

					if (vm.sourcesLocal.indexOf('services') >= 0 && responses[serviceIndex].success)
						vm.reportRecordsServices = responses[serviceIndex].data

					if (vm.sourcesLocal.indexOf('projects') >= 0 && responses[projectIndex].success) 
						vm.reportRecordsProjects = responses[projectIndex].data

					vm.renderReport()

					vm.renderGraph = true
				})
			}
		}
	},
	created() {
		let vm = this

		this.reportPeriod = this.periodOptions[0].value


		if (this.value)
			this.reportPeriod = this.value

		if (!this.sources)
			this.sourcesLocal = ["projects","services"]
		else
			this.sourcesLocal = this.sources

		if (this.customerId) {

			this.fetchReportRange(
				this.dateStart.format("YYYY"),
				this.dateStart.format("M"),
				this.dateEnd.format("YYYY"),
				this.dateEnd.format("M")
			)
		}
	}
}
</script>